/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum JobStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  CANCELLED = 'CANCELLED',
}
